"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initGrafanaPassport = exports.GrafanaPassportDefault = void 0;
var _uuid = require("uuid");
var initGrafanaPassport = exports.initGrafanaPassport = function initGrafanaPassport() {
  return {
    id: {
      value: (0, _uuid.v4)()
    },
    name: "",
    description: "",
    url: "",
    username: "",
    password: "",
    isConnected: false
  };
};
var GrafanaPassportDefault = exports.GrafanaPassportDefault = function GrafanaPassportDefault() {
  return {
    id: {
      value: (0, _uuid.v4)()
    },
    name: "",
    description: "",
    isConnected: false,
    url: "",
    password: "",
    username: ""
  };
};